import Vue from 'vue'
// axios
import axios from 'axios'

const baseURL = process.env.VUE_APP_BASE_URL

if (!baseURL) {
  throw new Error('VUE_APP_BASE_URL must explicitly select the admin API destination')
}

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL,
  timeout: 100000,
})

let unauthorizedHandler
axiosIns.setUnauthorizedHandler = handler => { unauthorizedHandler = handler }

axiosIns.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) {
    if (unauthorizedHandler && !(error.config && error.config.skipUnauthorizedHandler)) unauthorizedHandler()
  }
  return Promise.reject(error)
})

Vue.prototype.$http = axiosIns

export default axiosIns
